export default "__VITE_ASSET__CGKGdiNU__"